import {
  overParseJson,
  checkAttendantAndFetch,
} from '../utils/requestUtils';

const GET_HISTORY_API_URL = 'https://afiliados.uol.com.br/api/getCampaignFormatHistory.html';
const INSERT_HISTORY_API_URL = 'https://afiliados.uol.com.br/api/insertCampaignFormatHistory.html';
const HTTP_ERROR = 'HTTP_ERROR';
const DEFAULT_FETCH_OPTIONS = {
  credentials: 'same-origin',
};

class HistoryApi {
  static buildGetHistoryPayload(options) {
    return JSON.stringify({
      formatHistoryRequest: {
        idt_person: options.idtPerson,
        idt_product_source: options.idtProductSource,
      },
    });
  }

  static buildInsertHistoryPayload(options) {
    const formatHistoryRequest = {};
    formatHistoryRequest.idt_person = options.idtPerson;
    formatHistoryRequest.idt_product_source = options.idtProductSource;
    formatHistoryRequest.format = options.format;
    formatHistoryRequest.category = options.category;
    formatHistoryRequest.content = options.content;
    formatHistoryRequest.site = options.site;

    if (options.idtFormat !== null && options.idtFormat !== undefined) {
      formatHistoryRequest.idt_format = options.idtFormat;
    }

    if (options.description !== null && options.description !== undefined) {
      formatHistoryRequest.description = options.description;
    }

    if (options.label !== null && options.label !== undefined) {
      formatHistoryRequest.label = options.label;
    }
    return JSON.stringify({ formatHistoryRequest });
  }

  static async getHistoryList(options) {
    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      const body = this.buildGetHistoryPayload(options);

      const fetchResponse = await checkAttendantAndFetch(GET_HISTORY_API_URL, {
        method: 'POST',
        headers,
        body,
        ...DEFAULT_FETCH_OPTIONS,
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async insertHistory(payload) {
    try {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      const body = this.buildInsertHistoryPayload(payload);
      const fetchResponse = await checkAttendantAndFetch(INSERT_HISTORY_API_URL, {
        method: 'POST',
        headers,
        body,
        ...DEFAULT_FETCH_OPTIONS,
      });

      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default HistoryApi;
